import { all, call } from 'redux-saga/effects';
import { onSiteVisitsFlow, fetchOnSiteVisitFlow } from './on-site-visits/saga';

import { onSiteEventsFlow } from './on-sites/saga';

export function* onSiteManagerFlow() {
  yield all([call(onSiteVisitsFlow), call(onSiteEventsFlow), call(fetchOnSiteVisitFlow)]);
}
